import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonCrossCountrySkiing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.93 7.3c.248.08.497.12.745.12h-.005.01-.005A2.368 2.368 0 0 0 19.92 5.8l.23-.69a2.373 2.373 0 0 0-1.5-3 2.37 2.37 0 0 0-2.99 1.5l-.23.69c-.2.6-.15 1.24.13 1.81.28.57.77.99 1.37 1.19Zm.63-3.05c.05-.15.2-.25.35-.25.03 0 .11.02.11.02.12.04.19.13.21.18.02.05.06.16.02.28l-.23.69c-.06.19-.26.29-.46.23a.353.353 0 0 1-.21-.18.406.406 0 0 1-.02-.28l.23-.69Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.76 12.97c.08.03.16.03.24.03h-.01.01a1.003 1.003 0 0 0 .977-.792l.963-2.888a.992.992 0 0 0-.63-1.26.992.992 0 0 0-1.26.63l-.7 2.097a6.989 6.989 0 0 1-4.1-3.527l-.35-.71c-.25-.5-.85-.7-1.34-.45a1.01 1.01 0 0 0-.388.34L5.22 16.37c-.056.072-.1.15-.135.23L3.3 16.05a.997.997 0 0 0-1.25.66c-.16.53.13 1.09.66 1.25l10.12 3.11c2.01.62 4.08.93 6.18.93H21l.01.01c.55 0 1-.45 1-1s-.45-1-1-1h-1.99c-.212 0-.425-.004-.637-.01l1.557-4.68a.992.992 0 0 0-.63-1.26.992.992 0 0 0-1.26.63l-1.67 5.02a.954.954 0 0 0-.032.113 18.737 18.737 0 0 1-2.918-.653l-.351-.108 1.756-3.513A1.004 1.004 0 0 0 14.8 14.4l-2.627-3.503 1.66-2.073a8.999 8.999 0 0 0 5.497 4.036l.344.088.006.002.078.02h.002Zm-8.618 5.495 1.683-3.365-1.943-2.59-3.776 4.712 4.036 1.243Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPersonCrossCountrySkiing;
